"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SidePageTitle = void 0;
var _ChildComponentManager = require("../ChildComponentManager");
var _NewSidePageBody = _interopRequireDefault(require("./NewSidePageBody"));
var _NewSidePageContent = _interopRequireDefault(require("./NewSidePageContent"));
var _SidePage = require("./SidePage");
var _SidePageActions = require("./SidePageActions");
var _SidePageBody = _interopRequireDefault(require("./SidePageBody"));
var _SidePageCloseButton = require("./SidePageCloseButton");
var _SidePageContent = require("./SidePageContent");
var _SidePageSidebar = _interopRequireDefault(require("./SidePageSidebar"));
var _SidePageTitle = require("./SidePageTitle");
var _SidePageTab = require("./Tabs/SidePageTab");
var _SidePageTabs = require("./Tabs/SidePageTabs");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["onClose", "confirmOnClose", "open"],
  _excluded2 = ["onClick"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var GGSidePage = function GGSidePage(_ref) {
  var onClose = _ref.onClose,
    confirmOnClose = _ref.confirmOnClose,
    open = _ref.open,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChildComponentManager.ChildComponentManager, {
    swapChild: true,
    onClose: onClose,
    open: open,
    confirmOnClose: confirmOnClose,
    children: function children(additionalProps) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePage.SidePage, _objectSpread(_objectSpread({}, props), additionalProps));
    }
  });
};
GGSidePage.propTypes = {
  active: _propTypes["default"].bool,
  backdrop: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node, _propTypes["default"].func]),
  confirmOnClose: _propTypes["default"].bool,
  loading: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  onExited: _propTypes["default"].func,
  open: _propTypes["default"].bool,
  size: _propTypes["default"].string,
  swap: _propTypes["default"].bool,
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};
var SidePageTitle = exports.SidePageTitle = function SidePageTitle(_ref2) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  var _useChildComponentMan = (0, _ChildComponentManager.useChildComponentManager)(),
    onClose = _useChildComponentMan.onClose;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePageTitle.SidePageTitle, _objectSpread({
    onClose: onClose
  }, props));
};
SidePageTitle.propTypes = {
  subTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  title: _propTypes["default"].string,
  actions: _propTypes["default"].object,
  onClose: _propTypes["default"].func
};
GGSidePage.Title = SidePageTitle;
GGSidePage.Content = _SidePageContent.SidePageContent;
GGSidePage.Actions = _SidePageActions.SidePageActions;
GGSidePage.Tabs = _SidePageTabs.SidePageTabs;
GGSidePage.Tab = _SidePageTab.SidePageTab;
GGSidePage.Sidebar = _SidePageSidebar["default"];
GGSidePage.Body = _SidePageBody["default"];
GGSidePage.NewBody = _NewSidePageBody["default"];
GGSidePage.NewContent = _NewSidePageContent["default"];
var SidePageCloseButton = function SidePageCloseButton(_ref3) {
  var onClickProp = _ref3.onClick,
    props = _objectWithoutProperties(_ref3, _excluded2);
  var _useChildComponentMan2 = (0, _ChildComponentManager.useChildComponentManager)(),
    onClose = _useChildComponentMan2.onClose;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePageCloseButton.SidePageCloseButton, _objectSpread({
    onClick: onClickProp || onClose
  }, props));
};
GGSidePage.CloseButton = SidePageCloseButton;
var _default = exports["default"] = GGSidePage;